import { render, staticRenderFns } from "./Filtragem.vue?vue&type=template&id=6fafa0f8"
import script from "./Filtragem.vue?vue&type=script&lang=js"
export * from "./Filtragem.vue?vue&type=script&lang=js"
import style0 from "./Filtragem.vue?vue&type=style&index=0&id=6fafa0f8&prod&lang=css"
import style1 from "./Filtragem.vue?vue&type=style&index=1&id=6fafa0f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports